import * as React from 'react';
import Theme from '../../theme';
import { StyleProp, StyleSheet, Text, TextStyle, View, ViewStyle, Platform } from 'react-native';
import { moderateScale } from 'react-native-size-matters';

interface IProps {
  initials: string;
  size: number;
  color: string;
  backgroundColor: string;
  style?: ViewStyle;
  containerStyle?: ViewStyle;
  textStyle?: StyleProp<TextStyle>;
}

export const InitialsCircle = ({
  initials,
  size,
  color,
  backgroundColor,
  style,
  textStyle,
  containerStyle,
}: IProps) => {
  return (
    <View>
      <View style={[styles.icon, {
        backgroundColor,
        height: size,
        width: size,
        borderRadius: size / 2,
        ...containerStyle,
      },
        style]}>
        <Text style={[styles.text, {
          fontSize: moderateScale(11, 0.4),
          color,
        }, textStyle]}>
          {initials}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  icon: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  text: {
    color: Theme.RED,
    fontFamily: Platform.OS === 'web' ? Theme.Weight600 : Theme.Custom900,
    backgroundColor: 'transparent',
  },
});
